import { render, staticRenderFns } from "./AddWebsite.vue?vue&type=template&id=243e9a8a&"
import script from "./AddWebsite.vue?vue&type=script&lang=js&"
export * from "./AddWebsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports